import { useState } from 'react'
import { Operation } from 'fast-json-patch'
import { useTranslation } from 'react-i18next'

import { useFetch } from '../useFetch'
import { useAuth } from '../../contexts/AuthContext'

import { CONFIG } from '../../config'
import { ApiError } from '../../types/exception/errorStatus'
import { UserProfile } from '../../types/user/userProfile'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useUpdateProfile() {
  const { t } = useTranslation(['account', 'exceptions'])

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<string | null>(null)

  const { authInfo } = useAuth()
  const { patcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
    setSuccess(null)
  }

  const updateProfile = async (patch: Operation[], successMessage?: string) => {
    setLoading(true)
    setError(null)
    setSuccess(null)

    try {
      const data = await patcher<UserProfile>(
        `${CONFIG.BOUNCE_API}/api/v1/profile`,
        patch,
        'application/json-patch+json'
      )

      if (data) {
        setSuccess(successMessage ?? null)
        return data
      }
    } catch (caughtError) {
      console.error(caughtError)
      setError(
        caughtError instanceof ApiError
          ? getErrorMessage(caughtError.data)
          : t('exceptions:unknown')
      )
    } finally {
      setLoading(false)
    }
  }

  return {
    updateProfile,
    loading,
    error,
    success,
    resetState,
  }
}
